/*
 * Application Insights JavaScript SDK - Common, 2.8.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


import { createEnumStyle } from "@microsoft/applicationinsights-core-js";
/**
 * Defines the level of severity for the event.
 */
export var SeverityLevel = createEnumStyle({
    Verbose: 0 /* Verbose */,
    Information: 1 /* Information */,
    Warning: 2 /* Warning */,
    Error: 3 /* Error */,
    Critical: 4 /* Critical */
});
//# sourceMappingURL=SeverityLevel.js.map